import { ColumnInterface } from '@shared/interfaces/column.interface'
import { ColumnsOptionsCanceledOrdersEnum } from '@shared/components/trading/widgets/orders-widget/core/enums/options/columns-options-canceled-orders.enum'

export const ColumnsOptionsCanceledOrdersConstant: ColumnInterface<ColumnsOptionsCanceledOrdersEnum>[] = [
	{
		column: ColumnsOptionsCanceledOrdersEnum.tickerCompany,
		visible: true,
	},
	{
		column: ColumnsOptionsCanceledOrdersEnum.operation,
		visible: true,
	},
	{
		column: ColumnsOptionsCanceledOrdersEnum.quantity,
		visible: true,
	},
	{
		column: ColumnsOptionsCanceledOrdersEnum.price,
		visible: true,
	},
	{
		column: ColumnsOptionsCanceledOrdersEnum.term,
		visible: true,
	},
	{
		column: ColumnsOptionsCanceledOrdersEnum.orderType,
		visible: true,
	},
	{
		column: ColumnsOptionsCanceledOrdersEnum.executed,
		visible: true,
	},
	{
		column: ColumnsOptionsCanceledOrdersEnum.statusTitle,
		visible: true,
	},
]
